export const uiConfig = {
    linearBackground: (deg)=>`linear-gradient(${deg}, #33ff57 , #33ff57 ,#ff33f6 , #ff33f6 ,#0000FF ,  #0000FF ,#FFD700 , #FFD700 ,#5733ff , #5733ff,#33f6ff, #33f6ff,#ff5733, #ff5733)`
}